import { ICreditCondition } from '@r1-frontend/api-domru/payments/v1/credits/condition';

import { InferValueTypes } from '~/src/store';

import * as actions from '../actions';
import { ECrediteActions } from '../actions/actionTypes';

export type TAction = ReturnType<InferValueTypes<typeof actions>>

export interface ICreditInitialState {
    isShowDetails: boolean,
    isShowOptionSelect: boolean,
    selectedCreditCondition: ICreditCondition | null,
}

export const initialState: ICreditInitialState = {
    isShowDetails: false,
    isShowOptionSelect: false,
    selectedCreditCondition: null,
};

export const reducer = (state: ICreditInitialState = initialState, action: TAction): ICreditInitialState => {
    switch (action.type) {
        case ECrediteActions.SetIsShowDetails:
            return {
                ...state,
                isShowDetails: action.payload,
            };
        case ECrediteActions.SetIsShowOptionSelect:
            return {
                ...state,
                isShowOptionSelect: action.payload,
            };
        case ECrediteActions.SetSelectedCreditCondition:
            return {
                ...state,
                selectedCreditCondition: action.payload,
            };
        default:
            return { ...state };
    }
};
